import { render } from "./GptNames.vue?vue&type=template&id=25a681f1&scoped=true"
import script from "./GptNames.vue?vue&type=script&lang=js"
export * from "./GptNames.vue?vue&type=script&lang=js"

import "./GptNames.vue?vue&type=style&index=0&id=25a681f1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a681f1"]])

export default __exports__